import { useState } from "react";
import { Button } from "V2.0/common/button";
import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import { PlusIcon } from "@heroicons/react/24/outline";
import { AssistantAgentForm } from "./AssistantAgentForm";

function AssistantAgentCreate(props) {
  const { createAssistantAgent, assistantOptions } = props;

  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (data) => {
    const startLoading = () => setLoading(true);
    const stopLoading = () => setLoading(false);
    const onSuccess = () => {
      stopLoading();
      setOpen(false);
    };

    createAssistantAgent(data, stopLoading, startLoading, onSuccess);
  };

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <PlusIcon /> Add Agent
      </Button>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogTitle>Add Assistant Agent</DialogTitle>
        <DialogBody>
          <AssistantAgentForm
            defaultAssistantAgent={{}}
            assistantOptions={assistantOptions}
            onSubmit={handleSubmit}
            onCancel={() => setOpen(false)}
            loading={loading}
            setLoading={setLoading}
            buttonInfo={{
              buttons: "2",
              primaryLabel: "Add",
              secondaryLabel: "Cancel",
            }}
          />
        </DialogBody>
      </Dialog>
    </>
  );
}

export { AssistantAgentCreate };
